import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import Styles from '../../story-filters-styles.module.scss';
import withComponentName from '../../../../decorators/withComponentName';

const cx = classNames.bind(Styles);

const CustomTimeFilterErrors = ({
  futureDateErr,
  pastMaxErr,
  endBeforeStartErr,
  dateFormatErr,
  timeFormatErr,
  earliestDateErr,
  errorsBlockClass,
  sameDayErr,
  isFilingsPage,
  maxDaysRangeErr,
}) => (
  <div className={cx('errors-block', errorsBlockClass, {
    visible: futureDateErr || pastMaxErr || endBeforeStartErr
    || dateFormatErr || earliestDateErr || maxDaysRangeErr,
  }, { 'mobile-big': pastMaxErr || sameDayErr })}
  >
    {futureDateErr && (
      <p className={Styles['period-error']}>
        Please select a date in the past
      </p>
    )}
    {pastMaxErr && (
      <p className={cx('period-error')}>
        Currently, you can not access data before
        {' '}
        {isFilingsPage ? '1 Jan 1864' : '2 Jan 2022'}
        .
        We will change this soon.
      </p>
    )}
    {endBeforeStartErr && (
      <p className={Styles['period-error']}>
        The end date cannot be before the start date.
      </p>
    )}
    {dateFormatErr && (
      <p className={Styles['period-error']}>
        Please select a valid date dd-mm-yyyy.
      </p>
    )}
    {timeFormatErr && (
      <p className={Styles['period-error']}>
        Incorrect time value
      </p>
    )}
    {earliestDateErr && (
      <p className={Styles['period-error']}>
        Please select the start date within the last 1 year, or
        {' '}
        <Link to="/pricing">upgrade</Link>
        {' '}
        to remove this limit.
      </p>
    )}
    {sameDayErr && (
      <p className={cx('period-error')}>Start date and time cannot be same as end date and time</p>
    )}
    {maxDaysRangeErr && (
      <p className={cx('period-error')}>Please choose a period 30 days or shorter.</p>
    )}
  </div>
);

export default withComponentName(CustomTimeFilterErrors);
